// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),

 
   signIn: path(ROOTS_AUTH, '/sign-in'),
  register: path(ROOTS_AUTH, '/register'),

  signUp: path(ROOTS_AUTH, '/sign-up'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  resetMobPassword: path(ROOTS_AUTH, '/reset-mob-password'),
  changeFrontAccount: path(ROOTS_AUTH, '/front-account'),
  verify: path(ROOTS_AUTH, '/verify'),

   login2:path(ROOTS_AUTH,'/login2')
}; 

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    author: path(ROOTS_DASHBOARD, '/author'),
    book: path(ROOTS_DASHBOARD, '/book'),
    addbook: path(ROOTS_DASHBOARD, '/addbook'),
    editbook: path(ROOTS_DASHBOARD, '/addbook/0'),
    bookreview: path(ROOTS_DASHBOARD, '/bookreview'),
    authorreview: path(ROOTS_DASHBOARD, '/authorreview'),
    coach: path(ROOTS_DASHBOARD, '/coach'),
    audio: path(ROOTS_DASHBOARD, '/audio'),
    addaudio: path(ROOTS_DASHBOARD, '/addaudio'),
    editaudio: path(ROOTS_DASHBOARD, '/addaudio/0'),
    video: path(ROOTS_DASHBOARD, '/video'),
    addvideo: path(ROOTS_DASHBOARD, '/addvideo'),
    editvideo: path(ROOTS_DASHBOARD, '/addvideo/0'),
    coachreview: path(ROOTS_DASHBOARD, '/coachreview'),
    audioreview: path(ROOTS_DASHBOARD, '/audioreview'),
    videoreview: path(ROOTS_DASHBOARD, '/videoreview'),   
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking')
  },
 
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
 
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
